{
  "REPORT": {
    "HEADER": "Sarunas",
    "LOADING_CHART": "Notiek diagrammas datu ielāde...",
    "NO_ENOUGH_DATA": "Mēs neesam saņēmuši pietiekami daudz datu punktu, lai izveidotu pārskatu. Lūdzu, vēlāk mēģiniet vēlreiz.",
    "DOWNLOAD_CONVERSATION_REPORTS": "Download conversation reports",
    "DATA_FETCHING_FAILED": "Neizdevās izgūt datus. Lūdzu, vēlāk mēģiniet vēlreiz.",
    "SUMMARY_FETCHING_FAILED": "Neizdevās izgūt kopsavilkumu. Lūdzu, vēlāk mēģiniet vēlreiz.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Sarunas",
        "DESC": "( Kopā )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Saņemtās ziņas",
        "DESC": "( Kopā )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Nosūtītās ziņas",
        "DESC": "( Kopā )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Pirmās Atbildes Laiks",
        "DESC": "( Vidēji )",
        "INFO_TEXT": "Kopējais aprēķiniem izmantoto sarunu skaits:",
        "TOOLTIP_TEXT": "Pirmās Atbildes Laiks ir {metricValue} (pamatojoties uz {conversationCount} sarunām)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Atrisināšanas Laiks",
        "DESC": "( Vidēji )",
        "INFO_TEXT": "Kopējais aprēķiniem izmantoto sarunu skaits:",
        "TOOLTIP_TEXT": "Atrisināšanas Laiks ir {metricValue} (pamatojoties uz {conversationCount} sarunām)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Atrisināšanas Skaits",
        "DESC": "( Kopā )"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "Atrisināšanas Skaits",
        "DESC": "( Kopā )"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Nodošanas Skaits",
        "DESC": "( Kopā )"
      },
      "REPLY_TIME": {
        "NAME": "Klienta gaidīšanas laiks",
        "TOOLTIP_TEXT": "Gaidīšanas laiks ir {metricValue} (pamatojoties uz {conversationCount} atbildēm)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "LAST_7_DAYS": "Pēdējās 7 dienas",
      "LAST_14_DAYS": "Pēdējās 14 dienas",
      "LAST_30_DAYS": "Pēdējās 30 dienas",
      "THIS_MONTH": "This month",
      "LAST_MONTH": "Last month",
      "LAST_3_MONTHS": "Pēdējie 3 mēneši",
      "LAST_6_MONTHS": "Pēdējie 6 mēneši",
      "LAST_YEAR": "Pagājušais gads",
      "CUSTOM_DATE_RANGE": "Pielāgots datumu diapazons"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Pielietot",
      "PLACEHOLDER": "Izvēlieties datumu diapazonu"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "Grupēt Pēc",
    "DURATION_FILTER_LABEL": "Ilgums",
    "GROUPING_OPTIONS": {
      "DAY": "Diena",
      "WEEK": "Nedēļa",
      "MONTH": "Mēnesis",
      "YEAR": "Gads"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Diena"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Diena"
      },
      {
        "id": 2,
        "groupBy": "Nedēļa"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Diena"
      },
      {
        "id": 2,
        "groupBy": "Nedēļa"
      },
      {
        "id": 3,
        "groupBy": "Mēnesis"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 2,
        "groupBy": "Nedēļa"
      },
      {
        "id": 3,
        "groupBy": "Mēnesis"
      },
      {
        "id": 4,
        "groupBy": "Mēnesis"
      }
    ],
    "BUSINESS_HOURS": "Darba Laiks",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Notīrīt filtru",
      "EMPTY_LIST": "Nav atrasts"
    },
    "DRILLDOWN": {
      "TITLE": "{metric} details",
      "RESULT_COUNT_CONVERSATION": "{count} conversation | {count} conversations",
      "RESULT_COUNT_MESSAGE": "{count} message | {count} messages",
      "EMPTY": "No records found for this bar.",
      "ERROR": "Could not load records. Please try again.",
      "ADMIN_ONLY": "Only administrators can drill down into report records.",
      "LOAD_MORE": "Ielādēt vairāk",
      "CLOSE": "Close details",
      "PREVIOUS_BUCKET": "Previous bar",
      "NEXT_BUCKET": "Next bar",
      "UNKNOWN_CONTACT": "Unknown contact",
      "UNKNOWN_INBOX": "Unknown inbox",
      "UNASSIGNED_AGENT": "Nav piešķirtas",
      "NO_MESSAGE_CONTENT": "No message content",
      "MESSAGE_CREATED_AT": "Message created at {time}",
      "EVENT_OCCURRED_AT": "Event occurred at {time}",
      "INCOMING_MESSAGE": "Incoming message",
      "OUTGOING_MESSAGE": "Outgoing message"
    },
    "PAGINATION": {
      "RESULTS": "Rāda {start} līdz {end} no {total} rezultātiem",
      "PER_PAGE_TEMPLATE": "{size} / page"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "Aģentu Pārskats",
    "DESCRIPTION": "Easily track agent performance with key metrics such as conversations, response times, resolution times, and resolved cases. Click an agent's name to learn more.",
    "LOADING_CHART": "Notiek diagrammas datu ielāde...",
    "NO_ENOUGH_DATA": "Mēs neesam saņēmuši pietiekami daudz datu punktu, lai izveidotu pārskatu. Lūdzu, vēlāk mēģiniet vēlreiz.",
    "DOWNLOAD_AGENT_REPORTS": "Lejupielādēt aģentu pārskatus",
    "FILTER_DROPDOWN_LABEL": "Izvēlieties Aģentu",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "AGENTS": "Meklēt aģentus"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Sarunas",
        "DESC": "( Kopā )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Ienākošie ziņojumi",
        "DESC": "( Kopā )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Izejošie ziņojumi",
        "DESC": "( Kopā )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Pirmās Atbildes Laiks",
        "DESC": "( Vidēji )",
        "INFO_TEXT": "Kopējais aprēķiniem izmantoto sarunu skaits:",
        "TOOLTIP_TEXT": "Pirmās Atbildes Laiks ir {metricValue} (pamatojoties uz {conversationCount} sarunām)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Atrisināšanas Laiks",
        "DESC": "( Vidēji )",
        "INFO_TEXT": "Kopējais aprēķiniem izmantoto sarunu skaits:",
        "TOOLTIP_TEXT": "Atrisināšanas Laiks ir {metricValue} (pamatojoties uz {conversationCount} sarunām)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Atrisināšanas Skaits",
        "DESC": "( Kopā )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Pēdējās 7 dienas"
      },
      {
        "id": 1,
        "name": "Pēdējās 30 dienas"
      },
      {
        "id": 2,
        "name": "Pēdējie 3 mēneši"
      },
      {
        "id": 3,
        "name": "Pēdējie 6 mēneši"
      },
      {
        "id": 4,
        "name": "Pagājušais gads"
      },
      {
        "id": 5,
        "name": "Pielāgots datumu diapazons"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Pielietot",
      "PLACEHOLDER": "Izvēlieties datumu diapazonu"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "Etiķešu Pārskats",
    "DESCRIPTION": "Track label performance with key metrics including conversations, response times, resolution times, and resolved cases. Click a label name for detailed insights.",
    "LOADING_CHART": "Notiek diagrammas datu ielāde...",
    "NO_ENOUGH_DATA": "Mēs neesam saņēmuši pietiekami daudz datu punktu, lai izveidotu pārskatu. Lūdzu, vēlāk mēģiniet vēlreiz.",
    "DOWNLOAD_LABEL_REPORTS": "Lejupielādēt etiķešu pārskatus",
    "FILTER_DROPDOWN_LABEL": "Izvēlieties Etiķeti",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "LABELS": "Meklēt etiķetes"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Sarunas",
        "DESC": "( Kopā )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Ienākošie ziņojumi",
        "DESC": "( Kopā )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Izejošie ziņojumi",
        "DESC": "( Kopā )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Pirmās Atbildes Laiks",
        "DESC": "( Vidēji )",
        "INFO_TEXT": "Kopējais aprēķiniem izmantoto sarunu skaits:",
        "TOOLTIP_TEXT": "Pirmās Atbildes Laiks ir {metricValue} (pamatojoties uz {conversationCount} sarunām)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Atrisināšanas Laiks",
        "DESC": "( Vidēji )",
        "INFO_TEXT": "Kopējais aprēķiniem izmantoto sarunu skaits:",
        "TOOLTIP_TEXT": "Atrisināšanas Laiks ir {metricValue} (pamatojoties uz {conversationCount} sarunām)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Atrisināšanas Skaits",
        "DESC": "( Kopā )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Pēdējās 7 dienas"
      },
      {
        "id": 1,
        "name": "Pēdējās 30 dienas"
      },
      {
        "id": 2,
        "name": "Pēdējie 3 mēneši"
      },
      {
        "id": 3,
        "name": "Pēdējie 6 mēneši"
      },
      {
        "id": 4,
        "name": "Pagājušais gads"
      },
      {
        "id": 5,
        "name": "Pielāgots datumu diapazons"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Pielietot",
      "PLACEHOLDER": "Izvēlieties datumu diapazonu"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "Iesūtnes Pārskats",
    "DESCRIPTION": "Ātri apskatiet iesūtnes veiktspēju, izmantojot galvenos rādītājus, piemēram, sarunas, atbildes laikus, atrisināšanas laikus un atrisinātos gadījumus. Lai iegūtu plašāku informāciju, noklikšķiniet uz iesūtnes nosaukuma.",
    "LOADING_CHART": "Notiek diagrammas datu ielāde...",
    "NO_ENOUGH_DATA": "Mēs neesam saņēmuši pietiekami daudz datu punktu, lai izveidotu pārskatu. Lūdzu, vēlāk mēģiniet vēlreiz.",
    "DOWNLOAD_INBOX_REPORTS": "Lejupielādēt iesūtnes pārskatus",
    "FILTER_DROPDOWN_LABEL": "Izvēlieties Iesūtni",
    "ALL_INBOXES": "All Inboxes",
    "SEARCH_INBOX": "Search Inbox",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "INBOXES": "Search inboxes"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Sarunas",
        "DESC": "( Kopā )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Ienākošie ziņojumi",
        "DESC": "( Kopā )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Izejošie ziņojumi",
        "DESC": "( Kopā )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Pirmās Atbildes Laiks",
        "DESC": "( Vidēji )",
        "INFO_TEXT": "Kopējais aprēķiniem izmantoto sarunu skaits:",
        "TOOLTIP_TEXT": "Pirmās Atbildes Laiks ir {metricValue} (pamatojoties uz {conversationCount} sarunām)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Atrisināšanas Laiks",
        "DESC": "( Vidēji )",
        "INFO_TEXT": "Kopējais aprēķiniem izmantoto sarunu skaits:",
        "TOOLTIP_TEXT": "Atrisināšanas Laiks ir {metricValue} (pamatojoties uz {conversationCount} sarunām)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Atrisināšanas Skaits",
        "DESC": "( Kopā )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Pēdējās 7 dienas"
      },
      {
        "id": 1,
        "name": "Pēdējās 30 dienas"
      },
      {
        "id": 2,
        "name": "Pēdējie 3 mēneši"
      },
      {
        "id": 3,
        "name": "Pēdējie 6 mēneši"
      },
      {
        "id": 4,
        "name": "Pagājušais gads"
      },
      {
        "id": 5,
        "name": "Pielāgots datumu diapazons"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Pielietot",
      "PLACEHOLDER": "Izvēlieties datumu diapazonu"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "Komandas Pārskats",
    "DESCRIPTION": "Get a snapshot of your team's performance with essential metrics, including conversations, response times, resolution times, and resolved cases. Click a team name for more details.",
    "LOADING_CHART": "Notiek diagrammas datu ielāde...",
    "NO_ENOUGH_DATA": "Mēs neesam saņēmuši pietiekami daudz datu punktu, lai izveidotu pārskatu. Lūdzu, vēlāk mēģiniet vēlreiz.",
    "DOWNLOAD_TEAM_REPORTS": "Lejupielādēt komandas pārskatus",
    "FILTER_DROPDOWN_LABEL": "Izvēlieties Komandu",
    "FILTERS": {
      "ADD_FILTER": "Pievienot filtru",
      "CLEAR_ALL": "Notīrīt visu",
      "NO_FILTER": "Nav pieejami filtri",
      "INPUT_PLACEHOLDER": {
        "TEAMS": "Meklēt komandas"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Sarunas",
        "DESC": "( Kopā )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Ienākošie ziņojumi",
        "DESC": "( Kopā )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Izejošie ziņojumi",
        "DESC": "( Kopā )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Pirmās Atbildes Laiks",
        "DESC": "( Vidēji )",
        "INFO_TEXT": "Kopējais aprēķiniem izmantoto sarunu skaits:",
        "TOOLTIP_TEXT": "Pirmās Atbildes Laiks ir {metricValue} (pamatojoties uz {conversationCount} sarunām)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Atrisināšanas Laiks",
        "DESC": "( Vidēji )",
        "INFO_TEXT": "Kopējais aprēķiniem izmantoto sarunu skaits:",
        "TOOLTIP_TEXT": "Atrisināšanas Laiks ir {metricValue} (pamatojoties uz {conversationCount} sarunām)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Atrisināšanas Skaits",
        "DESC": "( Kopā )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Pēdējās 7 dienas"
      },
      {
        "id": 1,
        "name": "Pēdējās 30 dienas"
      },
      {
        "id": 2,
        "name": "Pēdējie 3 mēneši"
      },
      {
        "id": 3,
        "name": "Pēdējie 6 mēneši"
      },
      {
        "id": 4,
        "name": "Pagājušais gads"
      },
      {
        "id": 5,
        "name": "Pielāgots datumu diapazons"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Pielietot",
      "PLACEHOLDER": "Izvēlieties datumu diapazonu"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "CSAT Pārskati",
    "NO_RECORDS": "No responses yet",
    "NO_RECORDS_DESCRIPTION": "CSAT survey responses will appear here once customers start providing feedback.",
    "DOWNLOAD": "Lejupielādēt CSAT Pārskatus",
    "DOWNLOAD_FAILED": "Neizdevās lejupielādēt CSAT Pārskatus",
    "FILTERS": {
      "ADD_FILTER": "Pievienot filtru",
      "CLEAR_ALL": "Notīrīt visu",
      "NO_FILTER": "Nav pieejami filtri",
      "INPUT_PLACEHOLDER": {
        "AGENTS": "Meklēt aģentus",
        "INBOXES": "Search inboxes",
        "TEAMS": "Meklēt komandas",
        "RATINGS": "Search ratings"
      },
      "AGENTS": {
        "LABEL": "Aģents"
      },
      "INBOXES": {
        "LABEL": "Iesūtne"
      },
      "TEAMS": {
        "LABEL": "Komanda"
      },
      "RATINGS": {
        "LABEL": "Vērtējums"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "Kontaktpersona",
        "AGENT_NAME": "Aģents",
        "RATING": "Vērtējums",
        "FEEDBACK_TEXT": "Atsauksmes komentārs",
        "CONVERSATION": "Saruna",
        "CUSTOMER": "Customer",
        "RESPONSE": "Atbilde",
        "HANDLED_BY": "Handled by"
      },
      "UNKNOWN_CUSTOMER": "Unknown customer"
    },
    "NO_AGENT": "No assigned agent",
    "NO_FEEDBACK": "No feedback provided",
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "Kopējais atbilžu skaits",
        "TOOLTIP": "Kopējais apkopoto atbilžu skaits"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "Apmierinātības rādītājs",
        "TOOLTIP": "Kopējais pozitīvo atbilžu skaits / Kopējais atbilžu skaits * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "Atbildes ātrums",
        "TOOLTIP": "Kopējais atbilžu skaits / Kopējais nosūtīto CSAT aptaujas ziņojumu skaits * 100"
      },
      "RATING_DISTRIBUTION": "Rating distribution"
    },
    "REVIEW_NOTES": {
      "TITLE": "Review notes",
      "PLACEHOLDER": "Add review notes about this rating...",
      "SAVE": "Saglabāt",
      "CANCEL": "Atcelt",
      "SAVING": "Notiek saglabāšana...",
      "SAVED": "Notes saved successfully",
      "SAVE_ERROR": "Failed to save notes",
      "UPDATED_BY": "Updated by {name} {time}",
      "UPDATED_BY_LABEL": "Updated by",
      "PAYWALL": {
        "TITLE": "Upgrade to add review notes",
        "AVAILABLE_ON": "The review notes feature is only available in the Business and Enterprise plans.",
        "UPGRADE_PROMPT": "Add internal context to every CSAT response with review notes. Capture what really happened, spot patterns faster, and make better decisions from your feedback.",
        "UPGRADE_NOW": "Pāriet uz maksas versiju tagad",
        "CANCEL_ANYTIME": "Jūs varat jebkurā laikā mainīt vai atcelt savu versiju"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Robotu Atskaites",
    "METRIC": {
      "TOTAL_CONVERSATIONS": {
        "LABEL": "Sarunu Skaits",
        "TOOLTIP": "Kopējais robota apstrādāto sarunu skaits"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "Kopējais atbilžu skaits",
        "TOOLTIP": "Kopējais robota nosūtīto atbilžu skaits"
      },
      "RESOLUTION_RATE": {
        "LABEL": "Atrisināšanas Apjoms",
        "TOOLTIP": "Kopējais robota atrisināto sarunu skaits / kopējais robota apstrādāto sarunu skaits * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "Nodošanas Apjoms",
        "TOOLTIP": "Kopējais aģentiem nodoto sarunu skaits / kopējais robota apstrādāto sarunu skaits * 100"
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "Pārskats",
    "LIVE": "Tiešraide",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "Atvērt Sarunas",
      "LOADING_MESSAGE": "Notiek sarunu metrikas ielāde...",
      "OPEN": "Atvērt",
      "UNATTENDED": "Bez uzraudzības",
      "UNASSIGNED": "Nav piešķirtas",
      "PENDING": "Gaida"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Sarunu Satiksme",
      "NO_CONVERSATIONS": "Nav sarunu",
      "CONVERSATION": "{count} saruna",
      "CONVERSATIONS": "{count} sarunas",
      "DOWNLOAD_REPORT": "Lejupielādēt atskaiti"
    },
    "RESOLUTION_HEATMAP": {
      "HEADER": "Resolutions",
      "NO_CONVERSATIONS": "Nav sarunu",
      "CONVERSATION": "{count} saruna",
      "CONVERSATIONS": "{count} sarunas",
      "DOWNLOAD_REPORT": "Lejupielādēt atskaiti"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "Aģentu sarunas",
      "LOADING_MESSAGE": "Notiek aģentu metrikas ielāde...",
      "NO_AGENTS": "Aģentu sarunas nenotiek",
      "TABLE_HEADER": {
        "AGENT": "Aģents",
        "OPEN": "Atvērt",
        "UNATTENDED": "Bez uzraudzības",
        "STATUS": "Statuss"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "Visas Komandas",
      "HEADER": "Komandu sarunas",
      "LOADING_MESSAGE": "Notiek komandu metrikas ielāde...",
      "NO_TEAMS": "Dati nav pieejami",
      "TABLE_HEADER": {
        "TEAM": "Komanda",
        "OPEN": "Atvērt",
        "UNATTENDED": "Bez uzraudzības",
        "STATUS": "Statuss"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "Aģenta statuss",
      "ONLINE": "Tiešsaistē",
      "BUSY": "Aizņemts",
      "OFFLINE": "Bezsaistē"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Svētdiena",
    "MONDAY": "Pirmdiena",
    "TUESDAY": "Otrdiena",
    "WEDNESDAY": "Trešdiena",
    "THURSDAY": "Ceturtdiena",
    "FRIDAY": "Piektdiena",
    "SATURDAY": "Sestdiena"
  },
  "SLA_REPORTS": {
    "HEADER": "SLA Atskaites",
    "NO_RECORDS": "SLA sarunas nav pieejamas.",
    "LOADING": "Notiek SLA datu ielāde...",
    "DOWNLOAD_SLA_REPORTS": "Lejupielādēt SLA atskaites",
    "DOWNLOAD_FAILED": "Neizdevās lejupielādēt SLA atskaites",
    "DROPDOWN": {
      "ADD_FIlTER": "Pievienot filtru",
      "CLEAR_ALL": "Notīrīt visu",
      "CLEAR_FILTER": "Notīrīt filtru",
      "EMPTY_LIST": "Nav atrasts",
      "NO_FILTER": "Nav pieejami filtri",
      "SEARCH": "Meklēšanas filtrs",
      "INPUT_PLACEHOLDER": {
        "SLA": "SLA nosaukums",
        "AGENTS": "Aģenta vārds",
        "INBOXES": "Iesūtnes nosaukums",
        "LABELS": "Etiķetes nosaukums",
        "TEAMS": "Komandas nosaukums"
      },
      "SLA": "SLA politika",
      "INBOXES": "Iesūtne",
      "AGENTS": "Aģents",
      "LABELS": "Etiķete",
      "TEAMS": "Komanda"
    },
    "WITH": "ar",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Rezultātu Līmenis",
        "TOOLTIP": "Izveidoto SLA procentuālā daļa tika veiksmīgi pabeigta"
      },
      "NO_OF_MISSES": {
        "LABEL": "Nokavēto Skaits",
        "TOOLTIP": "Kopējais nokavēto SLA skaits noteiktā periodā"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Sarunu Skaits",
        "TOOLTIP": "Kopējais sarunu skaits ar SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Politika",
        "CONVERSATION": "Saruna",
        "AGENT": "Aģents"
      },
      "VIEW_DETAILS": "Skatīt Detaļas"
    }
  },
  "SUMMARY_REPORTS": {
    "INBOX": "Iesūtne",
    "AGENT": "Aģents",
    "TEAM": "Komanda",
    "LABEL": "Etiķete",
    "AVG_RESOLUTION_TIME": "Vid. Atrisināšanas Laiks",
    "AVG_FIRST_RESPONSE_TIME": "Vid. Pirmās Atbildes Laiks",
    "AVG_REPLY_TIME": "Vid. Klientu Gaidīšanas Laiks",
    "RESOLUTION_COUNT": "Atrisināšanas Skaits",
    "CONVERSATIONS": "Sarunu skaits"
  }
}
